import {
  Component,
  Injector,
  ViewEncapsulation,
  ViewChild,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { appModuleAnimation } from '@shared/animations/routerTransition';

@Component({
  templateUrl: './coming-soon.component.html',
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()],
})
export class ComingSoonComponent extends AppComponentBase {
  constructor(injector: Injector) {
    super(injector);
  }

  get containerClass(): string {
    if (this.appSession.theme.baseSettings.layout.layoutType === 'fluid') {
      return 'container-fluid';
    }

    return 'container';
  }
}
